import { Autocomplete, Box, Button, Dialog, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Theme, Typography, useTheme } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import BreadCrum from '../../lib/BreadCrum'
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { APPLICATION_TYPE, USER_ROLES } from '../../utils/constant';
import {isRMLikeRole, maskInfo } from '../../utils/utilityFunctions';
import NomineeCard from './NomineeCard';
import { BlueEditIcon, BluePlusIcon, whitePlusIconOutlined as WhitePlusIconOutlined, BluePlusIconOutlined, DeleteRedIcon, DialogCloseIcon, InfoIconOutlined, InfoIconSubtitle, PlusIcon, SearchIcon, YellowWarning } from '../../assets/SvgIcons';
import { getReportsInvestorList } from '../../redux-store/actions/reports';
import { RootStateType } from '../../redux-store/reducers';
import { ApplicationProps, NomineeType, ReportsListRes } from '../../redux-store/types/api-types';
import { DropdownLoading } from '../analytics/loadingComponents';
import { SubHeading } from '../investors/components';
import { getApplicationDetails } from '../../redux-store/actions/application';
import { InvestorList, InvestorListBanksRes, investorListForBanks } from '../../redux-store/actions/bank';
import { BankCardSkeleton } from '../banks/BankCard';

export default function UpdateNominee(): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')
  const { role = "" } = useSelector((state: any) => state.auth);
  const { iwappRmId = "", applicationId: investorApplicationId = '' } = useSelector((state: RootStateType) => state.id);
  const [investorListLoading, setInvestorListLoading] = useState<boolean>(false);
  const [investorList, setInvestorList] = useState<InvestorListBanksRes>({} as InvestorListBanksRes);
  const [selectedInvestor, setSelectedInvestor] = useState<InvestorList>({} as InvestorList);
  const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)
  const [selectedInvestorData, setSelectedInvestorData] = useState<ApplicationProps>({} as ApplicationProps);
  const [isApplicationLoading, setApplicationLoading] = useState<boolean>(false);
  const [selectedInvClientCode, setSelectedInvClientCode] = useState<string>('');
  const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio);


  const fetchInvestorList = async () => {
    try {
      setInvestorListLoading(true);
      const payload = {
        rmId: `${iwappRmId}`
      }
      const response = await (dispatch(investorListForBanks(payload)) as unknown as Promise<InvestorListBanksRes>);
      setInvestorList(response);
    } catch (error) {
      console.log((error as Error)?.message);
    } finally {
      setInvestorListLoading(false);
    }
  };

  useEffect(() => {
    if (isRMLikeRole(role)) {
      fetchInvestorList();
    }
  }, [])

  // useEffect(() => {
  //   setApplicationLoading(true);
  //   try {
  //     if (selectedInvestor?.applicationId || investorApplicationId) {
  //       (async () => {
  //         const res = await (dispatch(getApplicationDetails((`${selectedInvestor?.applicationId ?? ''}` || `${investorApplicationId ?? ''}`) ?? ''))) as unknown as ApplicationProps;
  //         if (!res) {
  //           return;
  //         }
  //         setSelectedInvestorData(res);
  //       })()
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     setApplicationLoading(false);
  //   }

  // }, [selectedInvestor]);
  useEffect(() => {
    if (selectedInvestor?.applicationId || investorApplicationId) {
      setApplicationLoading(true);
      (async () => {
        try {
          const res = await dispatch(
            getApplicationDetails(
              (`${selectedInvestor?.applicationId ?? ''}` || `${investorApplicationId ?? ''}`) ?? ''
            )
          ) as unknown as ApplicationProps;

          if (res) {
            setSelectedInvestorData(res);
          }
        } catch (e) {
          console.log(e);
        } finally {
          setApplicationLoading(false);
        }
      })();
    }
  }, [selectedInvestor, investorApplicationId]);




  // const handleInvestorChange = (event: SelectChangeEvent) => {
  //   const selectedInvestorObj = investorList?.result?.find((obj) => obj.customerName === event.target.value);
  //   setSelectedInvestor(selectedInvestorObj ?? {} as InvestorList);
  // };

  const handleInvestorChange = async (selectedObj?: ({ label: string; value: string; } | null)) => {
    if (isRMLikeRole(role) && !selectedObj) {
      setSelectedInvestor({} as InvestorList)
      setSelectedInvClientCode('');
      return;
    }
    const selectedInvestor = investorList?.result?.find(
      (item: InvestorList) => item?.clientCode === selectedObj?.value
    ) as InvestorList;
    setSelectedInvClientCode(selectedObj?.value ?? "")
    setSelectedInvestor(selectedInvestor ?? {} as InvestorList);
  }

  const handleNoInvestorDialogClose = () => {
    setNoInvestorDialogVisible(false)
  }

  const rmRouterPath =
    [
      {
        name: 'Dashboard',
        path: '/dashboard',
        warning: false
      },
      {
        name: 'Update Nominee',
        path: `/${initialRouter[0]}`,
      },
    ]

  const investorRouterPath = [
    {
      name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
      path: '/investor-dashboard',
    },
    {
      name: 'Update Nominee',
      path: `/${initialRouter[0]}`,
    },

  ]

  const isInvestorSelected =
    !!selectedInvestor.applicationId ||
    (role === USER_ROLES.INVESTOR && !!investorApplicationId);

  const isIndividual = selectedInvestorData?.applicationType === APPLICATION_TYPE.INDIVIDUAL;
  const isNonIndividual = selectedInvestorData?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
  const isRm = isRMLikeRole(role);
  const isInvestor = role === USER_ROLES.INVESTOR;


  const investorListOptions = useMemo(() => investorList?.result?.map(obj => ({
    label: obj?.customerName ?? "",
    value: obj?.clientCode ?? "",
    applicationType: obj?.applicationType ?? "",
  }))?.filter(obj => obj.applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL) ?? [], [investorList])


  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
      </Box>
      <Box mb="25px" mt={2}>
        <Typography variant='h1' color="text.primary">
          Update Nominee
        </Typography>
      </Box>
      {
        <Box
          sx={{
            p: { xs: "15px", sm: "25px" },
            bgcolor: "background.paper",
            boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
            borderRadius: '25px',
            minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
          }}>
          {isRm && (
            <Box sx={{ width: { xs: "100%", sm: '80%', lg: "50%", xl: '40%' }, marginTop: { xs: "10px", sm: "30px" } }}>
              {investorListLoading && (<DropdownLoading />)}
              {!investorListLoading && (
                // <FormControl fullWidth>
                //   <InputLabel id="investor-select">Select Investor*</InputLabel>
                //   <Select
                //     labelId="investor-select"
                //     value={selectedInvestor.customerName ?? ""}
                //     label="Select Investor*"
                //     onChange={handleInvestorChange}
                //     sx={{ borderRadius: '8px', ...theme.typography.body_500 }}
                //   >
                //     {investorList?.result?.map(obj => (
                //       <MenuItem
                //         key={obj.customerName}
                //         value={obj.customerName}
                //         sx={{ ...theme.typography.body_500 }}
                //         disabled={obj?.applicationType?.toLowerCase() === 'non_individual'}
                //       >
                //         {maskInfo(obj?.customerName ?? "")}
                //       </MenuItem>
                //     ))}
                //   </Select>
                // </FormControl>
                <Autocomplete
                  value={investorListOptions?.find((item) => item?.value === selectedInvClientCode) ?? null}
                  onChange={(event, newValue) => {
                    handleInvestorChange(newValue); // pass clientCode directly
                  }}
                  options={investorListOptions}
                  getOptionDisabled={(option) =>
                    option?.applicationType?.toLowerCase() === APPLICATION_TYPE.NON_INDIVIDUAL
                  }
                  getOptionLabel={(option) => `${option?.label}(${option?.value})`}
                  getOptionKey={(option) => option?.value}
                  noOptionsText="No investors found"
                  sx={{
                    width: '100%',
                    borderRadius: '50px'
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Investor..."
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        disableUnderline: true,
                        sx: {
                          borderRadius: '8px',
                          backgroundColor: theme.palette.common.white,
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '8px',
                          },
                        },
                      }}
                    />
                  )}
                />
              )}
            </Box>
          )}
          {isInvestorSelected ?
            (
              <>
                <Box
                  sx={{
                    mt: '20px',
                    p: { xs: '10px 10px', md: "35px" },
                    bgcolor: "background.paper",
                    boxShadow: `0px 4px 5px 0px ${theme.palette.common.black}0D`,
                    borderRadius: '15px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                  }}>
                  <Box mb={{ xs: 2, sm: 5 }} sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'space-between', gap: { xs: '2px' } }}>
                    <Box>
                      <Typography variant='h2' color="text.primary">
                        {isRm ? "Selected Investor Nominees" : "Your Nominees"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', columnGap: '5px' }}>
                      <Box
                        sx={{
                          color: 'common.white',
                          backgroundColor: 'customColors.subtitle',
                          padding: { xs: '6px 8px', sm: '6px 8px' },
                          display: 'flex',
                          alignItems: 'flex-start ',
                          gap: '6px',
                          borderRadius: '8px',
                          maxWidth: '450px',
                          ...theme.typography.overline_400,
                        }}>
                        <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'flex-start' }}>
                          <InfoIconSubtitle />
                        </Box>
                        A Maximum of 3 Nominees can be Added. Please ensure that the BSE Authentication is completed after Adding/Modifying the Nominee Details to ensure smooth Transactions.
                      </Box>
                    </Box>
                  </Box>
                  {/* nominees listing */}

                  <Grid container spacing={3}>
                    {isApplicationLoading ?
                      (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                        >
                          <BankCardSkeleton />
                        </Grid>
                      )
                      :
                      ((selectedInvestorData?.nominees ?? []).length > 0 && isIndividual)
                        ?
                        (selectedInvestorData?.nominees?.map((nominee: NomineeType, index: number) => (
                          <Grid item key={index} xs={12} md={6} lg={4}>
                            <NomineeCard nominee={nominee} index={index} isLoading={isApplicationLoading} />
                          </Grid>
                        )))
                        :
                        (!isApplicationLoading && isIndividual) ?
                          (
                            <Box mb={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', px: { xs: 2, sm: 3 }, minHeight: { xs: "200px", sm: "300px", md: "calc(100vh - 495px)" }, textAlign: { xs: "center", md: "left" }, }}>
                              <Typography variant='body_600' color="text.primary">
                                No Nominee Added Click on Add Nominee to add a Nominee
                              </Typography>
                            </Box>
                          ) : isNonIndividual &&
                          (
                            <Box mb={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', minHeight: 'calc(100vh - 495px)', textAlign: { xs: "center" }, whiteSpace: { xs: "break-spaces" }, ml: { xs: "20px" } }}>
                              <Typography variant='body_600' color="text.primary">
                                Nominee cannot be added to Non Individual Investor
                              </Typography>
                            </Box>
                          )
                    }
                  </Grid>
                </Box>
                {((!isNonIndividual && !isApplicationLoading && isInvestor) || isRm) &&
                  (<Box
                    component={'button'}
                    aria-label={selectedInvestorData?.nominees && selectedInvestorData.nominees.length > 0 ? 'Add or edit nominee' : 'Add nominee'}
                    sx={{
                      padding: '10px',
                      mt: '20px',
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.primary[500]}`,
                      background: theme.palette.primary[500],
                      textAlign: 'center',
                      cursor: 'pointer',

                      width: { xs: "200px", sm: "100%" }, mx: { xs: "auto", sm: "0" },
                      display: { xs: "flex" }, justifyContent: { xs: "center" }, alignItems: { xs: "center" }
                    }}
                    onClick={() => history.push(`/nominee/edit-nominee`, { applicationId: (selectedInvestor?.applicationId || investorApplicationId) ?? "" })}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: '5px' }}>
                      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', padding: '8px' }}>
                        <WhitePlusIconOutlined />
                      </Box>
                      <Typography
                        variant='body_500'
                        sx={(theme: Theme) => ({
                          color: theme.palette.primary[100]
                        })}>
                        {selectedInvestorData?.nominees && selectedInvestorData.nominees.length > 0 ? 'Add/Edit Nominee' : 'Add Nominee'}
                      </Typography>
                    </Box>
                  </Box>)
                }
              </>
            ) :
            (
              <Box mb={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 'calc(100vh - 495px)' }}>
                {(isIndividual && isInvestorSelected)
                  ?
                  <Typography variant='body_600' color="text.primary">
                    No Nominee Added Click on Add Nominee to add a Nominee
                  </Typography>
                  : (isNonIndividual && isInvestor && isInvestorSelected) ? (<Typography variant='body_600' color="text.primary">
                    Nominee cannot be added to Non Individual Investor
                  </Typography>) :
                    (<Typography variant='body_600' color="text.primary">
                      Select the Investor to View Details
                    </Typography>)
                }
              </Box>
            )}
        </Box >
        //   (isNonIndividual && isInvestor) && (
        //     <Box
        //       sx={{
        //         p: "25px",
        //         bgcolor: "background.paper",
        //         boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
        //         borderRadius: '25px',
        //         minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
        //       }}>
        //       <Box mb={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 'calc(100vh - 495px)' }}>
        //         <Typography variant='body_600' color="text.primary">
        //           Nominee cannot be added to Non Individual Investor
        //         </Typography>
        //       </Box>
        //     </Box>
        //   )
      }
      <Dialog
        onClose={handleNoInvestorDialogClose}
        open={isNoInvestorDialogVisible}
        maxWidth='sm'
        sx={(theme: Theme) => ({
          '& .MuiPaper-root': {
            borderRadius: '12px',
            backgroundColor: theme.palette.common.white,
            padding: "22px 24px",
            width: "533px",
          },
        })}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Box
              sx={{
                display: "flex",
                columnGap: "12px",
                alignItems: "center"
              }}
            >
              <YellowWarning />
              <Typography
                variant="h2"
                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
              >
                No Investor Found!!
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={handleNoInvestorDialogClose}
              sx={{
                padding: "5px"
              }}
            >
              <DialogCloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Dialog>
    </>
  )
}

